// @mui
import { TableHeaderCell } from "@interfaces/tables";
import {
  Checkbox,
  TableRow,
  TableCell,
  TableHead,
  TableSortLabel,
} from "@mui/material";

interface ListTableHeadProps {
  rowCount: number;
  headLabel: TableHeaderCell[];
  numSelected: number;
  showCheckbox?: boolean;
  onSelectAllClick: (event: any) => void;
}

export default function ListTableHead({
  showCheckbox = true,
  rowCount,
  headLabel,
  numSelected,
  onSelectAllClick,
}: ListTableHeadProps) {
  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
          {showCheckbox ? (
            <Checkbox
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={rowCount > 0 && numSelected === rowCount}
              onChange={onSelectAllClick}
            />
          ) : null}
        </TableCell>
        {headLabel.map((headCell: TableHeaderCell) => (
          <TableCell key={headCell.id} align={"center"}>
            <TableSortLabel hideSortIcon>{headCell.label}</TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
